<template>
  <div class="loading">
    <div class="container">
      <BaseLockup class="lockup"/>
    </div>
  </div>
</template>

<script>
import BaseLockup from '@/components/BaseLockup/BaseLockup'
import { mapState } from 'vuex'
export default {
  name: 'loading',
  components: {
    BaseLockup
  },
  async mounted () {
    this.$store.commit('ui/setLoading', true)
    await this.checkLoginStatus()
    this.reroute()
  },
  beforeDestroy () {
    this.$store.commit('ui/setLoading', false)
  },
  computed: mapState('user', [
    'userProfile'
  ]),
  methods: {
    async checkLoginStatus () {
      await this.$store.dispatch('user/getLoginStatus')
    },
    reroute () {
      if (!this.userProfile) return this.$router.push('/login')
      if (!localStorage.getItem('userHasSeenOptin')) return this.$router.push('/optin')
      else return this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.lockup {
  width: 100% !important;
  max-width: 20rem !important;
}
.subcopy {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}
</style>
